module.exports = __webpack_public_path__ + "static/img/sy_8.64a88cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_8.png
// module id = 0SAI
// module chunks = 1